export default __webpack_public_path__ + "static/media/pic3.40c87ff8.jpg";